// faqData.js

export const faqDataHome = [

    {
        question: '1. Which streaming services do you distribute to?',
        answer: 'We distribute to all the major streaming services: Spotify, Apple Music, TikTok, YouTube, Deezer, Tidal, and over 200 other streaming platforms and stores globally.',
    },
    {
        question: '2. How do you distribute my music for free?',
        answer: 'FM Digital Official offers free distribution through a process called "royalty capture." When royalties are received from Digital Service Providers, they are placed into the DeFi platform AAVE for a set period. During this time, the royalties earn interest, which we retain, while you keep 100% of the principal royalty amount. After this period, your earnings, beyond a minimal locked amount, are fully available for withdrawal. Unlike others that claim to be free, we truly are.',
    },
    {
        question: '3. How do I transfer my catalog from another distributor?',
        answer: `Transferring your catalog to FM Digital Official is simple. You'll need a few key pieces of information:`,
        bulletPoints: [
            'The UPC and ISRC (to help DSPs identify your existing release)',
            'Release title and track title(s)',
            'Artist(s) name(s)',
            'The original release date',
            'The exact same audio and cover art files from the previous release.'
        ],
    },
    {
        question: '4. Are there any fees, and do I keep all my royalties?',
        answer: `There are no upfront fees, and we offer four plans for music distribution:`,
        bulletPoints: [
            'Solo Creator: A free account for special requests. You keep 70% of your royalties, with FM Digital Official retaining 30%.',
            'Starter: ₹899 per release. You keep 70% of your royalties, with statements every quarter.',
            'Career Artist: ₹2999 - ₹9999. You keep 95% of your royalties, with statements every month.',
            'Label Executive: ₹12999 - ₹55999. You keep 95% of your royalties, with statements every month and a dedicated account manager.',
        ],
        additionalText: `FM Digital Official provides flexible options to suit your needs, whether you're just starting out or looking to maximize your revenue.`
    },
    {
        question: '5. Can I update or change my release after it\'s been distributed?',
        answer: 'Yes, you can update your release after distribution. However, certain changes, like updating metadata or replacing audio files, may require additional processing time. Contact our support team for specific changes.',
    },

];

export const faqDataPricing = [
    {
        question: '1. What is included in the Solo Creator plan?',
        answer: 'Solo Creator is a free account for special requests. It includes 20 artist profiles, 1 label, distribution to 190+ DSPs within 7 business days, your own UPC & ISRC, track credits, and 70% royalties with quarterly statements.',
    },
    // ... more FAQ items for the pricing page
];




// faqData.js

export const faqDataMusic = [
    {
        question: "What is music marketing?",
        answer: "Music marketing involves promoting your music to reach a wider audience. This includes strategies like social media promotion, playlist pitching, influencer partnerships, digital advertising, and more."
    },
    {
        question: "How can I promote my music on social media?",
        answer: "You can promote your music on social media by creating engaging content, collaborating with influencers, using targeted ads, sharing behind-the-scenes footage, and interacting with your fans."
    },
    {
        question: "What is playlist pitching, and how does it help in music marketing?",
        answer: "Playlist pitching is the process of submitting your music to be featured on playlists, especially on platforms like Spotify, Apple Music, and Gaana. Being featured on popular playlists can significantly increase your exposure and streams."
    },
    {
        question: "Can digital advertising help me reach more listeners?",
        answer: "Yes, digital advertising on platforms like Facebook, Instagram, YouTube, and Spotify can help target specific demographics, expand your reach, and attract new listeners to your music."
    },
    {
        question: "What role does content creation play in music marketing?",
        answer: "Content creation, including music videos, lyric videos, and social media posts, helps keep your audience engaged and promotes your music visually and creatively."
    }
];



export const faqDataFeaturePlaylist = [
    {
        question: "What is playlist pitching?",
        answer: "Playlist pitching is the process of submitting your music to playlist curators or platforms to get your songs featured on their playlists."
    },
    {
        question: "Do you guarantee playlist placement?",
        answer: "While we aim to feature as many tracks as possible, we cannot guarantee playlist placement. Playlist decisions are based on various factors, including track quality and playlist fit."
    },
    {
        question: "Can I submit the same track to multiple playlists?",
        answer: "Yes, you can submit your track to multiple playlists. However, ensure that the playlists are suitable for your music genre and style."
    },
    {
        question: "Is there a fee to submit my music for playlist pitching?",
        answer: "Submission policies can vary. Some platforms may charge a fee, while others offer free submissions. Check the specific guidelines for details."
    },
    {
        question: "How can I increase my chances of being featured on a playlist?",
        answer: "Ensure your track is of high quality and fits the playlist’s theme. Provide a compelling pitch and make sure to follow submission guidelines carefully."
    }
];
